// extracted by mini-css-extract-plugin
export default {"container":"_RbgEc","text":"e2uSG4","spinner":"r1qooR"};